module.exports = __webpack_public_path__ + "static/media/Abbott_Laboratories_logo.16547934.svg";